import { READER_REQUEST_TYPES, READER_REQUEST_BOX_READ_MODES, useFormState } from 'shared';

export function useCreateRequestForm(onChangeInput) {
  const [inputs, setInputs] = useFormState(
    {
      requestType: READER_REQUEST_TYPES.linkBoxRing,
      boxReadMode: READER_REQUEST_BOX_READ_MODES.mastercases
    },
    onChangeInput
  );

  const handleChange =
    fieldName =>
    ({ target }) => {
      setInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  function handleTobaccoProductAutocomplete(element) {
    setInputs(prevInputs => ({
      ...prevInputs,
      tobaccoProductId: element?.id,
      tobaccoProduct: element?.name
    }));
  }

  const handleChangeRequestType = value => {
    setInputs(prevInputs => {
      const isSelected = (prevInputs.requestType & value) > 0;

      let newValue = isSelected ? (prevInputs.requestType -= value) : (prevInputs.requestType += value);
      if (value === READER_REQUEST_TYPES.activateTags && !isSelected) {
        if (prevInputs.requestType & READER_REQUEST_TYPES.deactivateTags) {
          newValue = newValue -= READER_REQUEST_TYPES.deactivateTags;
        }
        if (prevInputs.requestType & READER_REQUEST_TYPES.replaceDefectiveTags) {
          newValue = newValue -= READER_REQUEST_TYPES.replaceDefectiveTags;
        }
      } else if (value === READER_REQUEST_TYPES.deactivateTags && !isSelected) {
        if (prevInputs.requestType & READER_REQUEST_TYPES.activateTags) {
          newValue = newValue -= READER_REQUEST_TYPES.activateTags;
        }
        if (prevInputs.requestType & READER_REQUEST_TYPES.replaceDefectiveTags) {
          newValue = newValue -= READER_REQUEST_TYPES.replaceDefectiveTags;
        }
      } else if (value === READER_REQUEST_TYPES.linkBoxRing && !isSelected) {
        if (prevInputs.requestType & READER_REQUEST_TYPES.replaceDefectiveTags) {
          newValue = newValue -= READER_REQUEST_TYPES.replaceDefectiveTags;
        }
      } else if (value === READER_REQUEST_TYPES.setProductionDate && !isSelected) {
        if (prevInputs.requestType & READER_REQUEST_TYPES.replaceDefectiveTags) {
          newValue = newValue -= READER_REQUEST_TYPES.replaceDefectiveTags;
        }
      } else if (value === READER_REQUEST_TYPES.replaceDefectiveTags && !isSelected) {
        newValue = READER_REQUEST_TYPES.replaceDefectiveTags;
      }
      return {
        ...prevInputs,
        requestType: newValue || READER_REQUEST_TYPES.linkBoxRing,
        ringAmount: (newValue & READER_REQUEST_TYPES.replaceDefectiveTags) > 0 ? prevInputs.ringAmount : '',
        observations: (newValue & READER_REQUEST_TYPES.replaceDefectiveTags) > 0 ? prevInputs.observations : '',
        amountToRead: (newValue & READER_REQUEST_TYPES.replaceDefectiveTags) === 0 ? prevInputs.amountToRead : '',
        productionDate: (newValue & READER_REQUEST_TYPES.setProductionDate) > 0 ? prevInputs.productionDate : '',
        boxReadMode: (newValue & READER_REQUEST_TYPES.replaceDefectiveTags) === 0 ? prevInputs.boxReadMode : ''
      };
    });
  };

  return {
    inputs,
    handleChange,
    handleTobaccoProductAutocomplete,
    handleChangeRequestType
  };
}
